


















import { Vue, Component, Prop } from 'vue-property-decorator';
import BasePopper from '../base-popper/_base-popper.vue';
import gaClickOutside from '../../directives/ga-click-outside';

@Component({
  name: 'BaseDropdown',
  components: {
    BasePopper,
  },
  directives: {
    gaClickOutside,
  },
})
export default class BaseDropdown extends Vue {
  @Prop({ default: () => [0, 0] }) offset: [number, number];
  @Prop({ default: false }) sameWidthAsRef: boolean;

  open = false;

  handleClick() {
    this.open = !this.open;
  }

  handleHide() {
    this.open = false;
  }
}
